// src/pages/CourseTime/components/ProgressBar.comp.jsx
import React, {useEffect, useState} from 'react';
import * as S from '../styles';
import { getActiveThemeColor } from '../../../utils/utils';
import { GET_APP_LOCALIZE_TEXT } from '../../../utils/dq_lc_service/lc_service';

const ProgressBar = ({
  sessionContent,
  activeSegment,
  currentSlideIndex,
  profile,
  isLastSlideOfSegment,
  isEndOfCourse,
  nextSegmentKey,
  nextSegmentLabel,
  nextSession,
  endOfSegmentRef,
  onContinueToNextSegment,
  onGoToHome,
  onContinueToNextSession,
  segmentIndex = 0,
  // Assessment validation props
  activityCompleted,
  isActivityRequired,
  themeColor,
  // Control when to show popup
  showSegmentCompletionPopup,
  onClosePopup,
  sidebarCollapsed = false,
  pageLc,
  // When true, the visual bar/marker/count is hidden (e.g. assessment slides show their
  // own per-question progress ring), but the segment-completion popup below still renders.
  hideBar = false
}) => {
  if (!sessionContent || !activeSegment || !Array.isArray(sessionContent[activeSegment])) {
    return null;
  }

  const totalSlides = sessionContent[activeSegment].length;
  const progressPercentage = ((currentSlideIndex + 1) / totalSlides) * 100;
  const activeThemeColor = themeColor || getActiveThemeColor(profile);

  // Decide the completion message based on the upcoming segment (not by index),
  // so the text remains correct even if the sequence changes. Use segment key
  // (locale-independent) when available; labels are translated and cannot be compared.
  let completionMessage = GET_APP_LOCALIZE_TEXT(pageLc, 'ct__segment_completed');
  if (nextSegmentKey) {
    const key = String(nextSegmentKey);
    if (key === 'Seg4') completionMessage = GET_APP_LOCALIZE_TEXT(pageLc, 'ct__time_to_reflect');
    else if (key === 'Seg5') completionMessage = GET_APP_LOCALIZE_TEXT(pageLc, 'ct__review_learned');
    else completionMessage = GET_APP_LOCALIZE_TEXT(pageLc, 'ct__continue_next_segment');
  } else if (nextSegmentLabel && typeof nextSegmentLabel === 'string') {
    const lower = nextSegmentLabel.toLowerCase();
    if (lower.includes('reflect')) completionMessage = GET_APP_LOCALIZE_TEXT(pageLc, 'ct__time_to_reflect');
    else if (lower.includes('recap') || lower.includes('review')) completionMessage = GET_APP_LOCALIZE_TEXT(pageLc, 'ct__review_learned');
    else completionMessage = GET_APP_LOCALIZE_TEXT(pageLc, 'ct__continue_next_segment');
  } else if (isEndOfCourse) {
    completionMessage = GET_APP_LOCALIZE_TEXT(pageLc, 'ct__review_learned');
  }

  return (
    <S.ProgressRowContainer>
      {!hideBar && (
        <S.ProgressContainer>
          <S.ProgressBar
            style={{
              width: `${progressPercentage}%`,
              backgroundColor: activeThemeColor,
            }}
          />
          <S.ProgressMarker
            color={activeThemeColor}
            style={{
              left: `${progressPercentage}%`,
              transform: 'translateX(-50%)'
            }}
          />
          <S.ProgressText>
            <span style={{ color: activeThemeColor }}>{currentSlideIndex + 1}</span>
            <span style={{ color: '#ddd' }}>/ {totalSlides}</span>
          </S.ProgressText>
        </S.ProgressContainer>
      )}

      {showSegmentCompletionPopup && (
          <>
            <S.FullPageOverlay />
            <S.Overlay sidebarCollapsed={sidebarCollapsed}>
              <S.PopupContainer completed={isEndOfCourse} ref={endOfSegmentRef}>
              {/* Always show cross */}
              <S.CloseIcon themeColor={activeThemeColor} onClick={onClosePopup || (() => {})}>×</S.CloseIcon>

              {/* Then conditionally render the content */}
              {nextSegmentKey ? (
                  <>
                    <p>{completionMessage}</p>
                    <S.PopupButton themeColor={activeThemeColor} onClick={onContinueToNextSegment}>
                      {GET_APP_LOCALIZE_TEXT(pageLc, 'ct__continue_next_segment_button')}
                    </S.PopupButton>
                  </>
          ) : isEndOfCourse ? (
            <>
              <p>{GET_APP_LOCALIZE_TEXT(pageLc, 'ct__course_completed')}</p>
              <S.HomeButton onClick={onGoToHome}>
                {GET_APP_LOCALIZE_TEXT(pageLc, 'ct__return_home')}
              </S.HomeButton>
            </>
          ) : nextSession ? (
                  <>
                    <p>{GET_APP_LOCALIZE_TEXT(pageLc, 'ct__session_completed')}</p>
                    <S.PopupButton themeColor={activeThemeColor} onClick={onContinueToNextSession}>
                {GET_APP_LOCALIZE_TEXT(pageLc, 'ct__continue_next_session')}
                    </S.PopupButton>
                  </>
              ) : (
              <p>{GET_APP_LOCALIZE_TEXT(pageLc, 'ct__something_went_wrong')}</p>
              )}
              </S.PopupContainer>
            </S.Overlay>
          </>
      )}
    </S.ProgressRowContainer>
  );
};

export default ProgressBar;
